import { Label } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { memo } from 'react';

import { messages } from './EditPhoneInput.messages';
import { AreaTextField, CountryTextField, NumberTextField, Wrapper } from './EditPhoneInput.styles';
import type { EditPhoneInputProps } from './EditPhoneInput.types';

export const EditPhoneInput = memo<EditPhoneInputProps>((props) => {
    const { name, qa, label } = props;

    return (
        <div>
            <Label>{label}</Label>

            <Wrapper gridTemplateColumns='80px 80px auto'>
                <CountryTextField
                    name={`${name}.countryCode`}
                    qa={domHelpers.generateDataQa(qa, 'country-code')}
                    placeholder={messages.countryCodePlaceholder}
                    maxLength={constants.xeroConstants.PHONE_COUNTRY_CODE_MAX_LENGTH}
                />

                <AreaTextField
                    name={`${name}.areaCode`}
                    qa={domHelpers.generateDataQa(qa, 'area-code')}
                    placeholder={messages.areaCodePlaceholder}
                    maxLength={constants.xeroConstants.PHONE_AREA_CODE_MAX_LENGTH}
                />

                <NumberTextField
                    name={`${name}.number`}
                    qa={domHelpers.generateDataQa(qa, 'phone-number')}
                    placeholder={messages.phoneNumberPlaceholder}
                    maxLength={constants.xeroConstants.PHONE_NUMBER_MAX_LENGTH}
                />
            </Wrapper>
        </div>
    );
});

EditPhoneInput.displayName = 'EditPhoneInput';
